<template>
  <div style="margin-top: 20px">
    <!-- <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="fullPage"></loading> -->
    <div class="container maincontent">
      <!-- <div class="col-md-12"> -->
        <div class="row postdata">
          <div class="" style="margin-top: 20px">
            <div class="nav">
              <div class="box-header">
                <h3 class="box-title pageTitle">Schedule</h3>
              </div>
              <hr class="myline" />
              <div class="card">
                <div class="myIntRes">
                  <div class="card-header p-2 tabHeader"></div>
                </div>
                <div class="card-body">
                  <div class="tab-content">
                    <div class="active tab-pane" id="sent">
                      <div class="box-header with-border filterdata">
                        <input
                          v-model="postsearch"
                          @keyup="scheduleList()"
                          type="text"
                          class="form-control pull-left search-text"
                          placeholder="Search"
                          style="width: 50%; height: 30%"
                        />
                        <div style="width: 50%" class="pull-right filterby">
                          <div class="form-group">
                            <div
                              class="form-select pull-right"
                              style="width: 50%; height: 30%"
                            >
                              <select
                                @change="scheduleList()"
                                v-model="postsort"
                                class="form-control input-sm"
                              >
                                <option value="7">Last 7 days</option>
                                <option value="30">Last 30 days</option>
                              </select>
                              <span class="select-icon"
                                ><i class="fa fa-chevron-down"></i
                              ></span>
                            </div>
                          </div>
                          <span class="pull-right ml-1">Sort by</span>
                        </div>
                      </div>
                      <div class="text-center">
                        <div class="box-body">
                          <ul
                            style="list-style: none"
                            v-for="(schedule, index) in myscheduleList"
                            :key="index"
                          >
                            <li class="myPostArea">
                              <div class="postArea">
                                <div
                                  type="button"
                                  data-toggle="modal"
                                  data-target="#mypost"
                                  @click="myscheduleDetail(schedule)"
                                  class="myorgData"
                                >
                                  <div class="Orgimage">
                                    <img
                                      class="round"
                                      v-if="
                                        schedule.profile_picture != '' &&
                                        schedule.profile_picture != null
                                      "
                                      :src="`${schedule.profile_picture}`"
                                      alt=""
                                    />
                                    <img
                                      class="round"
                                      v-if="
                                        schedule.profile_picture == '' ||
                                        schedule.profile_picture == null
                                      "
                                      src="../../../assets/img/default.png"
                                      alt=""
                                    />
                                  </div>
                                  <div class="intDetails">
                                    <div class="uniqueId">
                                      <div style="font-size: 14px">
                                        <strong class="myorgName">{{
                                          schedule.organization
                                        }}</strong>

                                        <!-- <div class="val">
                                                <label for="">Validity:</label>
                                                <p>{{schedule.post_validity | formatDate}}</p>
                                              </div> -->
                                      </div>
                                    </div>
                                  </div>
                                                                  </div>

                                  <div class="val">
                                          <label for="" class="labelcss">Position: </label>
                                          <div style="font-size: 14px">
                                            <p class="mytitle">{{
                                              schedule.job_tittle
                                            }}</p>
                                          </div>
                                        </div>
                                <!-- <div class="">
                                  <div class="val">
                                    <label>Schedule Date -</label>
                                    <p>
                                      {{ schedule.schedule_date | formatDate }}
                                    </p>
                                  </div>
                                  <div class="val" v-if="schedule.status !== 'Reschedule Requested'">
                                    <label>Schedule Time -</label>
                                    <p>
                                      {{ schedule.schedule_start_time }} -
                                      {{ schedule.schedule_end_time }}
                                    </p>
                                  </div>
                                  <div class="val" v-else>
                                    <label>ReScheduled Time -</label>
                                    <p>
                                      {{ schedule.reschedule_start_time }} -
                                      {{ schedule.reschedule_end_time }}
                                    </p>
                                  </div>
                                </div> -->
                                <div class="interestbtn">
                                  <!-- <div class="openStatus">
                                          <button class="btn btn-success">Open</button>
</div> -->
                                  <span>
                                    <button class="btn btn-success" v-if="schedule.status == 'Reschedule Requested'" @click="rescheduleAccept(schedule)">Accept</button>
                                    <button class="btn btn-danger" v-if="schedule.status == 'Reschedule Requested'" @click="declineStatus='Reschedule';declinepopup(schedule._id, schedule.user_id)">Decline</button>
                                  </span>
                                  <div class="Intcost">
                                    <!-- <label for="">Status:</label> -->
                                    <p class="mystatus" >
                                    <span
                                      v-if="schedule.status === 'Cancelled'"
                                      style="color: #ff2627"
                                    >Cancelled</span>
                                    <!-- <span v-if="schedule.reschedule_status == 'Declined'" style="color: #ff2627">Declined</span> -->
                                    <span
                                      v-if="schedule.status === 'Reschedule Request Pending'"
                                      style="color: #5bad2b"
                                    >Reschedule Request Pending</span>
                                    <span
                                      v-if="schedule.status === 'Accepted'"
                                      style="color: #5bad2b"
                                    >Accepted</span>
                                    <span
                                      v-if="schedule.status === 'Open'"
                                      style="color: #5bad2b"
                                    >Open</span>
                                    <span
                                      v-if="schedule.status === 'Reschedule Requested'"
                                      style="color: #5bad2b">Reschedule Requested</span>
                                    <span
                                      v-if="schedule.status === 'Schedule Request'"
                                      style="color: #5bad2b">Schedule Requested</span>
                                      <span v-if="schedule.status === 'Auto-Declined'" style="color: #FAC213">Auto-Declined</span>
                                      <span
                                      v-if="schedule.reschedule_status === 'Declined'"
                                      style="color: #ff2627">Declined</span>
                                      </p>
                                  </div>
                                  <!-- <br> -->
                                  <div class="Intcost">
                                    <label for="" class="labelcss">Interview Cost: </label>
                                    <p class="Intcost">
                                      {{ schedule.currency_symbol }}
                                      {{ schedule.cost }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <hr
                                      style="margin-top:2px; margin-bottom:6px"
                                    />
                                    <div class="timeofInterest">
                                    <!-- <div class=""> -->
                                  <!-- <div class="val">
                                    <label>Schedule Date -</label>
                                    <p>
                                      {{ schedule.schedule_date | formatDate }}
                                    </p>
                                  </div>
                                  <div class="val" v-if="schedule.status !== 'Reschedule Requested'">
                                    <label>Schedule Time -</label>
                                    <p>
                                      {{ schedule.schedule_start_time }} -
                                      {{ schedule.schedule_end_time }}
                                    </p>
                                  </div>
                                  <div class="val" v-else>
                                    <label>ReScheduled Time -</label>
                                    <p>
                                      {{ schedule.reschedule_start_time }} -
                                      {{ schedule.reschedule_end_time }}
                                    </p>
                                  </div> -->
                                  <div class="vali">
                                          <label class="labelcss1" for="">Validity -</label>
                                          <p class="valdate">
                                            {{
                                              schedule.post_validity | formatDate
                                            }}
                                          </p>
                                        </div>
                                  <div class="vali">
                                    <label class="labelcss1">Schedule Date & Time -</label>
                                    <p class="valdate">
                                      {{ schedule.schedule_date | formatDate }} | {{ schedule.schedule_start_time }} -
                                      {{ schedule.schedule_end_time }}
                                    </p>
                                  </div>
                                  </div>
                                <!-- </div> -->
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <!-- Modal for #mypost -->
    <div
      class="modal fade"
      id="mypost"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title closebtnmodel" id="exampleModalLabel">
              <strong style="font-size: 18px"
                >Hi {{ firstName.first_name }}</strong
              >
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
          </div>
          <div class="modal-body modalbody">
                    <div class="myPostArea">

            <div class="postArea">
              <div class="myorgData1">
                <div class="Orgimage">
                  <img
                    class="profile-user-img img-fluid img-circle myprofile"
                    v-if="
                      mydata.profile_picture != '' &&
                      mydata.profile_picture != null
                    "
                    :src="`${mydata.profile_picture}`"
                    alt=""
                  />
                  <img
                    class="round"
                    v-if="
                      mydata.profile_picture == '' ||
                      mydata.profile_picture == null
                    "
                    src="../../../assets/img/default.png"
                    alt=""
                  />
                </div>
                <div class="intDetails">
                  <div class="uniqueId">
                    <div style="font-size: 15px">
                      <strong class="myorgName">{{ mydata.organization }}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div class="val">
                        <label for="" class="labelcss">Position: </label>
                        <div style="font-size: 13px">
                          <p class="mytitle">{{ mydata.job_tittle }}</p>
                        </div>
                      </div>
              <div class="popupinterestbtn">
                <!-- <button type="button" class="btn btn-danger myBookmark1"> -->
                <!-- <i
                    class="fa fa-thumbs-o-down fa-flip-horizontal bookmarkicon"
                    aria-hidden="true"
                  ></i> -->

                <div class="Intcost">
                  <!-- <label for="">Status:</label> -->
                  <p class="mytitle">
                                      <!-- <span v-if="mydata.status == 'Reschedule Request Pending'" style="color: #5bad2b">Reschedule Request Pending</span> -->
                                    <span
                                      v-if="mydata.status === 'Cancelled'"
                                      style="color: #ff2627"
                                    >Cancelled</span>
                                    <span
                                      v-if="mydata.status === 'Accepted'"
                                      style="color: #5bad2b"
                                    >Accepted</span>
                                    <span
                                      v-if="mydata.status === 'Open'"
                                      style="color: #5bad2b"
                                    >Open</span>
                                    <span
                                      v-if="mydata.status === 'Schedule Request'"
                                      style="color: #5bad2b">Schedule Request</span>
                                      <span v-if="mydata.status === 'Auto-Declined'" style="color: #FAC213">Auto-Declined</span>
                                      </p>
                  <span v-if="mydata.status == 'Cancelled'"></span>
                </div>
                <div class="Intcost">
                  <label for="" class="labelcss">Interview Cost:</label>
                  <p class="mytitle">
                    {{ mydata.currency_symbol }} {{ mydata.cost }}
                  </p>
                </div>
              </div>
            </div>
                    </div>
            <hr />
            <div class="dateandTime">
              <div class="myDate">
                <label for="" class="labelcss1">Scheduled Date - </label>
                <p class="mytitle">{{ mydata.schedule_date | formatDate }}</p>
              </div>
              <div class="divide"></div>
              <div class="myTime" v-if="mydata.status !== 'Reschedule Requested'">
                <label for="" class="labelcss1">Scheduled Time -</label>
                <p class="mytitle">
                  {{ mydata.schedule_start_time }} -
                  {{ mydata.schedule_end_time }}
                </p>
              </div>
              <div class="myTime" v-else>
                <label for="">Rescheduled Time -</label>
                <p>
                  {{ mydata.reschedule_start_time }} -
                  {{ mydata.reschedule_end_time }}
                </p>
              </div>
            </div>
            <hr />
            <div class="reSchedule">
              <button
                type="button"
                class="btn btn-success"
                data-toggle="modal"
                data-target="#reschedule"
                data-name="reschedule"
                @click="declinepopup(mydata._id)"
              v-if=" (mydata.status === 'Open' || mydata.status === 'Accept') && (mydata.status !== 'Schedule Request' || mydata.status !== 'Cancelled' || mydata.status !== 'Declined')">
               Reschedule
              </button>
              <button
                type="button"
                class="btn btn-danger myBookmark1"
                data-toggle="modal"
                data-target="#Cancel"
                @click="declinepopup(mydata._id)"
                v-if="(mydata.status === 'Open' || mydata.status === 'Accept') && (mydata.status !== 'Schedule Request' || mydata.status !== 'Cancelled' || mydata.status !== 'Declined')">
                Cancel
              </button>
              <span v-if="mydata.status == 'Reschedule Request Pending'" style="color: #5bad2b">Reschedule Request Pending</span>
              <span v-if="mydata.reschedule_status == 'Declined' " style="color: red">Declined</span>
            </div>
            <hr />
            <div class="scheduleDetails">
              <div class="postHead">
                <h4 class="h4" v-if="mydata.status == 'Open' || mydata.status == 'Schedule Request' || mydata.status == 'Accepted'">Candidate Details</h4>
                <h4 class="h4" v-if="mydata.status == 'Cancelled' || mydata.status == 'Auto-Declined'">Interview Details</h4>
              </div>
              <hr />
              <div class="resume">
                <label for="" class="labelcss">Resume</label>
                <!-- <p>{{ mydata.candidate_resume }}</p> -->
                <a type="download" class="btn btn-success mytitle" :href="mydata.candidate_resume">
                  <i
                    class="fa fa-download"
                    aria-hidden="true"
                    @click="downloadResume(mydata)"
                  ></i
                  >  Download
                </a>
              </div>
              <hr />
              <div class="postDatas">
                <div class="Intdetails">
                  <label for="" class="labelcss">Candidate Name :</label>
                  <p class="mytitle">{{ mydata.candidate_name }}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Experience :</label>
                  <p class="mytitle">
                    {{ scheduleData.candidate_year_of_experience }} years
                    {{ scheduleData.candidate_month_of_experience }} month
                  </p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Primary Skills :</label>
                  <p class="mytitle">{{ scheduleData.candidate_primaryskillnames }}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Secondary Skills :</label>
                  <p class="mytitle">{{ scheduleData.candidate_secondaryskillnames }}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Interview type :</label>
                  <p class="mytitle">{{ mydata.job_interview_type }}</p>
                </div>
                <div class="Intdetails">
                  <label for="" class="labelcss">Remarks :</label>
                  <p class="mytitle">{{mydata.comments}}</p>
                </div>
              </div>
            </div>
            <div class="JobDescription">
              <h4 class="h4">Job Description</h4>
              <hr />
              <p class="mytitle">
                <span>{{ mydata.org_description }}</span>
              </p>
            </div>
            <div v-if="mydata.status == 'Cancelled' && mydata.status == 'Open'">
            <hr>
            <div class="JobDescription">
              <h4 class="h4">Reason for Reschedule</h4>
              <hr />
              <p>
                <span>{{ mydata.reschedule_reason_name }}</span>
              </p>
            </div>
            <hr />
            <div class="comments" v-if="mydata.status">
              <h4 class="h4">Comments</h4>
              <hr />
              <div>
                <p>{{ mydata.reschedule_reason_comments }}</p>
              </div>
            </div>
            </div>
            <div  v-if="mydata.status == 'Cancelled'">
            <hr>
            <div class="JobDescription">
              <h4 class="h4">Reason for Cancellation</h4>
              <hr />
              <p>
                <span>{{ mydata.reason_name }}</span>
              </p>
            </div>
            <hr />
            <div class="comments">
              <h4 class="h4">Comments</h4>
              <hr />
              <div>
                <p>{{ mydata.reason_comments }}</p>
              </div>
            </div>
            </div>
            <div v-if="mydata.status == 'Declined'">
              <hr>
            <div class="JobDescription">
              <h4 class="h4">Reason for Declined</h4>
              <hr />
              <p>
                <span>{{ mydata.reason_name }}</span>
              </p>
            </div>
            <hr />
            <div class="comments">
              <h4 class="h4">Comments</h4>
              <hr />
              <div>
                <p>{{ mydata.reschedule_reason_comments }}</p>
              </div>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="InterestState">
              <button
                type="button"
                v-if="
                  mydata.status != 'Declined' && mydata.status != 'cancelled' && mydata.status != 'Auto-Declined' &&
                  (mydata.status == 'Accepted' || mydata.status == 'Accept' || mydata.status == 'Schedule Request' ) && mydata.status !== 'Reschedule Requested'
                "
                class="btn btn-danger myBookmark1"
                data-toggle="modal"
                data-target="#Cancel"
                @click="declinepopup(mydata._id)"
              >
                Decline
              </button>
              <button
                v-if="
                  mydata.status != 'Auto-Declined' && (mydata.status == 'Schedule Request' || mydata.status == 'Accept') && mydata.status !== 'Reschedule Requested'
                "
                @click="scheduleAccept(mydata._id, mydata.user_id)"
                class="btn btn-success"
                aria-hidden="true"
              >
                Accept
              </button>
              <button
                v-if="mydata.status === 'Reschedule Requested'"
                @click="rescheduleAccept(mydata)"
                class="btn btn-success"
                aria-hidden="true"
              >
                Accept
              </button>
              <button
                type="button"
                v-if="mydata.status === 'Reschedule Requested'"
                class="btn btn-danger myBookmark1"
                data-toggle="modal"
                data-target="#Cancel"
                @click="declineStatus='Reschedule'; declinepopup(mydata._id)"
              >
                Decline
              </button>
              <!-- <span v-if="mydata.status =='Accepted' && (mydata.statusval =='' || mydata.statusval ==null)" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span> -->
              <span
                v-if="mydata.statusval == 'Declined'"
                class="pull-right"
                style="color: #ff2627"
              >
                Declined</span
              >
              <span
                v-if="mydata.statusval == 'cancelled'"
                class="pull-right"
                style="color: #ff2627"
                >Cancelled</span
              >
              <button
                type="button"
                v-if="
                  mydata.status === 'Open'
                "
                class="btn btn-success myBookmark1"
                data-toggle="modal"
                @click="connect(mydata._id)"
              >
                Connect
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  modal for Cancel-->
    <div
      class="modal fade"
      id="Cancel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog deleteskillmodal" role="document">
        <div class="modal-content" style="width: 50%">
          <div class="modal-header">
            <h4 class="modal-title closebtnmodel" id="exampleModalLabel">
              Cancellation
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h4>
          </div>
          <div class="modal-body">
            <h4 class="skilltitle">Cancel the Interview Schedule</h4>
            <div>
              <div class="form-group">
                <div class="form-select">
                  <select
                    id="orgtype"
                    v-model="userReason"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.userReason.$error }"
                    @change="selectReason()"
                  >
                    <!-- <option>Select reason*</option>
                          <option v-for="reason in cancelList"
            :key="reason" :value="reason.value" class="text" disabled
                            >{{reason.value}}</option
                          > -->
                    <option value="">Select reason*</option>
                    <option
                      v-for="get in cancelList"
                      :key="get.value"
                      :value="get.value"
                    >
                      {{ get.value }}
                    </option>
                  </select>
                  <span class="select-icon"
                    ><i class="fa fa-chevron-down"></i
                  ></span>
                </div>
                <div
                  v-if="submitted && $v.userReason.$error"
                  class="invalid-feedback"
                  style="color: red; text-align: left"
                >
                  <span
                    v-if="!$v.userReason.required"
                    style="color: red; font-size: 12px"
                    >*select a Reason</span
                  >
                </div>
              </div>
              <textarea
                placeholder="Enter your comments*"
                class="invalid-feedback mytxtarea"
                name=""
                id=""
                cols="50"
                rows="5"
                v-model="comments"
                :class="{ 'is-invalid': submitted && $v.comments.$error }"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button v-if="declineStatus !== 'Reschedule'"
              type="button"
              class="btn"
              @click="scheduleCancel(receivePostId)"
            >
              Submit
            </button>
            <button v-if="declineStatus == 'Reschedule'"
              type="button"
              class="btn"
              @click="rescheduleCancel(receivePostId)"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  modal for Reschedule-->
    <div
      class="modal fade"
      id="reschedule"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog deleteskillmodal" role="document">
        <div class="modal-content" style="width: 50%">
          <div class="modal-header">
            <h4 class="modal-title closebtnmodel" id="exampleModalLabel">
              Reschedule
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </h4>
          </div>
          <div class="modal-body">
            <h4>Reschedule Reason</h4>
            <div>
              <div class="form-group">
                <div class="form-select">
                  <select
                    id="orgtype"
                    v-model="userReason"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.userReason.$error }"
                    @change="selectReason()"
                  >
                    <!-- <option>Select reason*</option>
                          <option v-for="reason in cancelList"
            :key="reason" :value="reason.value" class="text" disabled
                            >{{reason.value}}</option
                          > -->
                    <option value="">Select reason*</option>
                    <option
                      v-for="get in cancelList"
                      :key="get.value"
                      :value="get.value"
                    >
                      {{ get.value }}
                    </option>
                  </select>
                  <span class="select-icon"
                    ><i class="fa fa-chevron-down"></i
                  ></span>
                </div>
                <div
                  v-if="submitted && $v.userReason.$error"
                  class="invalid-feedback"
                  style="color: red; text-align: left"
                >
                  <span
                    v-if="!$v.userReason.required"
                    style="color: red; font-size: 12px"
                    >*select a Reason</span
                  >
                </div>
              </div>
              <textarea
                placeholder="Enter your comments*"
                class="invalid-feedback mytxtarea"
                name=""
                id=""
                cols="50"
                rows="5"
                v-model="comments"
                :class="{ 'is-invalid': submitted && $v.comments.$error }"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn"
              @click="reschedule(receivePostId)"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
import moment from 'moment'
import $ from 'jquery'

export default {
  data () {
    return {
      isLoading: true,
      postsearch: '',
      postsort: 7,
      fullPage: true,
      // user_id: 493,
      user_id: localStorage.getItem('user_id'),
      post_id: '',
      scheduleData: [],
      myscheduleList: [],
      myCurrentDate: '',
      myPastDate: '',
      startdate: '',
      enddate: '',
      status: '',
      mydata: [],
      scCancel: [],
      cancelList: [],
      reason_id: '',
      reason_name: '',
      comments: '',
      userReason: '',
      submitted: false,
      firstName: [],
      mySuccessmsg: '',
      scheduleId: '',
      cancel_by: '',
      declineStatus: '',
      mytime: []
    }
  },
  components: {},
  created () {
    localStorage.getItem('_id')
    this.firstName = JSON.parse(localStorage.getItem('user__details'))

    console.log(this.user_id)
    this.scheduleList()
    this.getCancelReason()
  },
  methods: {
    scheduleList () {
      this.myCurrentDate = moment().format('YYYY-MM-DD')
      console.log(this.myCurrentDate)
      this.myPastDate = moment()
        .subtract(this.postsort, 'days')
        .format('YYYY-MM-DD')
      console.log(this.myPastDate)
      const data = {
        user_id: localStorage.getItem('user_id'),
        sort: this.postsort,
        startdate: this.myPastDate,
        enddate: this.myCurrentDate,
        search: this.postsearch,
        status: this.status
      }
      axios
        .post(BaseURL + '/dashboard/get_schedulelist/mobile', {
          formData: data
        })
        .then((response) => {
          this.myscheduleList = response.data.scheduleList
          // this.mytime = response.data.scheduleList[1].startdatetime_utc
          console.log(this.mytime)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    myscheduleDetail (data) {
      this.mydata = data
      this.scheduleDetails(this.mydata._id)
      console.log(this.mydata)
    },
    scheduleDetails (_id) {
      this.scheduleId = _id
      axios
        .get(BaseURL + '/dashboard/get_schedule_detail/' + this.scheduleId)
        .then((response) => {
          this.scheduleData = response.data.scheduleList[0]
          console.log(this.scheduleData)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    scheduleCancel (postId) {
      $('#Cancel').modal('hide')
      $('#mypost').modal('hide')

      const data = {
        _id: postId,
        reason_id: this.reason_id,
        reason_name: this.reason_name,
        reason_comments: this.comments
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .post(
          BaseURL + '/dashboard/cancel_schedule/mobile',
          { formData: data },
          config
        )
        .then((response) => {
          this.scCancel = response.data.scheduleList
          this.receiveData.status = 'Accepted'
          this.receiveData.statuslabel = 'Declined'
          this.scheduleList()
          this.myscheduleDetails(this.data)
          this.scheduleDetails(this.mydata)

          this.$awn.success('Reason submitted Successfully')
          // this.btnHide = false
          // this.sent()
          console.log(this.myUnInterest)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    rescheduleCancel (postId) {
      $('#Cancel').modal('hide')
      $('#mypost').modal('hide')

      const data = {
        _id: postId,
        reason_id: this.reason_id,
        reason_name: this.reason_name,
        reason_comments: this.comments,
        cancel_by: 'interviewer'
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .post(
          BaseURL + '/dashboard/reschedule_cancel',
          { formData: data },
          config
        )
        .then((response) => {
          this.scCancel = response.data.scheduleList
          // this.receiveData.status = 'Accepted'
          // this.receiveData.statuslabel = 'Declined'
          this.scheduleList()
          this.myscheduleDetails(this.data)
          this.scheduleDetails(this.mydata)

          this.$awn.success('Reason submitted Successfully')
          // this.btnHide = false
          // this.sent()
          console.log(this.myUnInterest)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCancelReason () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .get(BaseURL + '/dashboard/get_cancel_reason/ios', config)
        .then((response) => {
          this.cancelList = response.data.reasonlist
          console.log(this.cancelList)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    selectReason () {
      for (var i = 0; i < this.cancelList.length; i++) {
        if (this.cancelList[i].value === this.userReason) {
          this.reason_id = this.cancelList[i]._id
          this.reason_name = this.cancelList[i].value
        }
      }
    },
    declinepopup (_id) {
      // $('#Cancel').modal('hide')

      console.log(this.mydata.status)
      this.receivePostId = _id
    },
    // reschedulepopup (_id) {
    //   console.log(this.mydata.status)
    //   this.receivePostId = _id
    // },
    reschedule (postId) {
      $('#reschedule').modal('hide')
      // $('#mypost').modal('hide')
      const data = {
        _id: postId,
        schedule_date: this.mydata.schedule_date,
        schedule_start_time: this.mydata.schedule_start_time,
        schedule_end_time: this.mydata.schedule_end_time,
        start_datetime: moment
          .utc(this.mydata.start_datetime)
          .format('YYYY-MM-DD HH:mm:ss'),
        end_datetime: moment
          .utc(this.mydata.end_datetime)
          .format('YYYY-MM-DD HH:mm:ss'),
        reschedule_reason_id: this.reason_id,
        reschedule_reason_name: this.reason_name,
        reschedule_reason_comments: this.comments
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios
        .post(
          BaseURL + '/dashboard/reschedule/mobile',
          {
            formData: data
          },
          config
        )
        .then((response) => {
          this.scheduleDetails(this.mydata._id)

          // this.scheduleList()
          // this.scheduleDetails()
          // this.$awn.success('Reschedule Successfully')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // rescheduleCancel (postId) {
    //   $('#Cancel').modal('hide')
    //   const data = {
    //     // user_id: localStorage.getItem('user_id'),
    //     _id: postId,
    //     reason_id: this.reason_id,
    //     reason_name: this.reason_name,
    //     comments: this.comments,
    //     cancel_by: this.cancel_by
    //   }
    //   const config = {
    //     headers: {
    //       'content-type': 'application/json',
    //       Authorization: 'Bearer ' + localStorage.getItem('token')
    //     }
    //   }
    //   axios
    //     .post(
    //       BaseURL + '/dashboard/reschedule_cancel',
    //       { formData: data },
    //       config
    //     )
    //     .then((response) => {
    //       this.scCancel = response.data.scheduleList
    //       this.receiveData.status = 'Accepted'
    //       this.receiveData.statuslabel = 'Declined'
    //       this.scheduleList()
    //       this.myscheduleDetails(this.data)
    //       this.scheduleDetails(this.mydata)

    //       this.$awn.success('Reason submitted Successfully')
    //       // this.btnHide = false
    //       // this.sent()
    //       console.log(this.myUnInterest)
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // },
    scheduleAccept (_id) {
      $('#mypost').modal('hide')

      this.scheduleId = _id
      axios.get(BaseURL + '/dashboard/schedule_accept/' + this.scheduleId)
        .then((response) => {
          this.scheduleList()
          this.scheduleDetails(this.mydata._id)
          this.$awn.success('Schedule Accepted Successfully')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    rescheduleAccept (schedule) {
      $('#mypost').modal('hide')

      const data = {
        _id: schedule.post_id,
        schedule_date: schedule.reschedule_date,
        schedule_start_time: schedule.reschedule_start_time,
        schedule_end_time: schedule.reschedule_end_time,
        start_datetime: schedule.restart_datetime,
        end_datetime: schedule.reend_datetime
      }
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }

      axios.post(BaseURL + '/dashboard/reschedule_accept/' + schedule._id,
        {
          formData: data
        },
        config
      )
        .then((response) => {
          // this.scheduleList()
          // this.scheduleDetails(this.mydata._id)
          // this.$awn.success('Reschedule Accepted Successfully')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    connect (_id) {
      // const data = {
      //   schedule_id: _id
      // }
      // const config = {
      //   headers: {
      //     'content-type': 'application/json',
      //     Authorization: 'Bearer ' + localStorage.getItem('token')
      //   }
      // }
      // axios.post(BaseURL + '/dashboard/add_schedule_connect', {
      //   formData: data
      // }, config).then((response) => {
      //   this.mySuccessmsg = response.data.message
      //   console.log(this.mySuccessmsg)
      //   // this.$awn.success('Connected Successfully')
      // }).catch((error) => {
      //   console.log(error)
      // })
    },
    downloadResume (data) {
      console.log(data)
    }
  },
  mounted: function () {
    this.downloadResume()
  }
}
</script>

<style lang="scss" scoped>
.postArea {
   width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px;
}
.postBg {
  background: #f5f5f5;
}
.maincontent {
  background-color: white;
  padding: 10px;
}
.myIntRes {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.tabHeader {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  // background-color: #f5f5f5;
}
.tabHeader .icon {
  display: none;
}
.tabBtn {
  display: flex;
  flex-direction: row;
}
.tabBtn > li > a {
  position: relative;
  display: block;
  // padding: 14px 27px;
  font-size: 14px;
  text-align: center;
}
.tabBtn > li.active > a,
.tabBtn > li.active > a:focus,
.tabBtn > li.active > a:hover {
  color: #fff;
  background-color: #5bad2b;
  border-top-color: unset;
}
.tabBtn > li > a:hover {
  // color: black;
  background-color: white;
}
.profile-user-img {
  margin: 0px auto;
  width: 130px;
  padding: 1px;
  border: 4px solid #d2d6de;
}
.img-circle {
  border-radius: 50%;
}
.myprofile {
  width: 120px;
  height: 120px;
}
.round {
  width: 100px;
  height: 100px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 4px;
}
.uniqueId {
  display: flex;
  text-align: start;
}
.position {
  display: flex;
  // text-align: start;
  flex-direction: row;
}
.val {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: baseline;
  column-gap: 3px;
}
.myorgData {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.myorgData:hover {
  cursor: pointer;
  // background-color: white;
}
.myorgData1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  column-gap: 16px;
  font-size: 12px;
}
.filterdata{
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 8px  0px;
}
.ml-1{
  margin-top: 6px;
 }
// .filterby{
//   align-items: center;
// }
.navTab {
  display: flex;
  justify-content: center;
}
.myBookmark {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 5px;
  align-content: center;
  align-items: baseline;
}
.openStatus {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.bookmarkicon {
  font-size: 15px;
}
.cancelicon {
  font-size: 18px;
  -webkit-text-stroke: 1px #d73925;
}
.interestbtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  row-gap: 2px;
  padding-right: 10px;
}
.popupinterestbtn {
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  row-gap: 0px;
}
.closebtnmodel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
}
.val {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-content: center;
  align-items: baseline;
  column-gap: 3px;
}
.scheduleDT{
   display: flex;
  flex-direction: row;
  justify-content: end;
  align-content: center;
  align-items: baseline;
  padding-right: 5px;
}
.postDatas {
  display: grid;
  grid-template-columns: 50% 50%;
}
.Intdetails {
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  align-items: baseline;
}
.Intdetails1 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 10px;
}
.timeofInterest {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0% 2% 0% 10%;
  column-gap: 10px;
}
.timeofInterest1 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: baseline;
  column-gap: 4px;
  font-size: 12px;
}
.timeofInterest2 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: baseline;
}
.postHead {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.sent {
  color: orange;
}
.received {
  color: blue;
}
.tabBtnRes1 {
  width: 50%;
}
.Intcost {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  column-gap: 5px;
  align-content: center;
  align-items: baseline;
}
.Intcost2 {
  display: flex;
  // flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  row-gap: 5px;
  align-content: center;
  align-items: center;
  column-gap: 5px;
}
.Intcost1 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  row-gap: 5px;
  align-content: center;
  align-items: center;
  row-gap: 10px;
}
.dateandTime {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.myDate,
.myTime {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  column-gap: 10px;
}
.divide {
  border-right: 1px solid #d2d6de;
}
.reSchedule {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.resume {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  column-gap: 10px;
  }
.mystatus {
  // width: 125px;
  // background-color: #5bad2b;
  // color: #5bad2b;
  border-radius: 10px;
  // text-align: center;
}
.mystatus6 {
  display: flex;
  justify-content: center;
  width: 75px;
  height: 25px;
  color: white;
  font-size: 12px;
  background-color: #5bad2b;
  // border-radius: 10px;
  text-align: center;
  align-items: center;
  // margin: 10px 0px 10px 0px;
}
.mystatus7 {
  display: flex;
  justify-content: center;
  width: 75px;
  height: 25px;
  color: white;
  background-color: #5bad2b;
  // border-radius: 10px;
  text-align: center;
  align-items: center;
  // margin: 10px 0px 10px 0px;
  font-size: 12px;
}
.mystatus8 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 90px;
  height: 30px;
  color: white;
  font-size: 13px;
  background-color: #5bad2b;
  // border-radius: 10px;
  text-align: center;
  align-items: center;
  // margin: 10px 0px 10px 0px;
}
.mystatus5 {
  display: flex;
  justify-content: center;
  width: 70px;
  height: 30px;
  color: white;
  background-color: #5bad2b;
  // border-radius: 10px;
  text-align: center;
  align-items: center;
  // margin: 10px 0px 10px 0px;
}
.mystatus1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: baseline;
  column-gap: 10px;
}
.mystatus2 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  row-gap: 10px;
}
.h4 {
  font-weight: 600;
}
.myline {
  margin-top: 0;
  margin-bottom: 0;
}
.pageTitle {
  font-size: 24px;
  font-weight: 400;
}
.widget-user .widget-user-image {
  left: 50%;
  margin-left: -60px;
  position: absolute;
  top: 70px;
}
.widget-user .widget-user-image > img {
  border: 3px solid #fff;
  height: 110px;
  width: 110px;
}

.widget-user .widget-user-header {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  height: 135px;
  padding: 1rem 0px 0px 0px;
  text-align: center;
}
.elevation-2 {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23) !important;
}
.img-circle {
  border-radius: 50%;
}
.card-widget {
  border: 0;
  position: relative;
}
.mypostCard {
  // flex: 0 0 33.333333%;
  max-width: 33.333333%;
}
.widget-user .card-footer {
  padding-top: 50px;
}
.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 0 solid rgba(0, 0, 0, 0.125);
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
.bg-info,
.bg-info > a {
  color: #fff !important;
}
.bg-info {
  background-color: #d2d6de !important;
}
.myintcost3 {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: center;
  align-items: baseline;
  column-gap: 5px;
}
.myintcost {
  width: 100%;
  height: 100px;
  padding-top: 37px;
  // padding-left: 30px;
  display: flex;
  justify-content: flex-end;
}
.myScheduletime {
  font-size: 12px;
}
.orgname {
  color: black;
}
// .shadow{
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;
//   justify-content: space-evenly;
// }
.accards {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}
.financialcard {
  /* From uiverse.io by @fanishah */
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  //  width: 40%;
  //  padding: 3px;
  //  height: 17rem;
  background-color: #f5f5f5;
  border-radius: 1rem;
  //  border: #212121 0.2rem solid;
  transition: all 0.4s ease-in;
  //  box-shadow: 0.4rem 0.4rem 0.6rem #00000040;
  // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.financialcard:hover {
  opacity: 0.8;
  transform: scale(1.1);
  //  border: black 0.2em solid;
  //  background-color: #5bad2b;
}
.accbtn {
  width: 100%;
  background-color: transparent;
  color: #5bad2b;
  padding: 0%;
}
.accbtn:hover {
  color: white;
}

.deleteskillmodal {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.skilltitle {
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.myorgName{
  font-size: 15px;
  font-weight: 600;
 }
 .myPostArea{
  border: 1px solid lightgray;
  border-radius: 5px;
  background-color: #f5f5f5;
}
.timeofInterest {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0% 1%;
  column-gap: 10px;
}
.vali {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-content: center;
  align-items: baseline;
  column-gap: 5px;
  padding-right: 5px;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {

.round{
  width: 80px;
  height: 80px;
}
.myprofile{
  width: 80px;
  height: 80px;
}
 .labelcss{
    font-size: 12px;
   }
   .labelcss1{
    font-size: 10px;
   }
   .valdate{
    font-size: 10px;
   }
   .myorgName{
    font-size: 12px;
   }
   .mytitle{
    font-size: 12px;
   }
   .myorgData{
    display: flex;
    flex-direction: column;
   }
   .myorgData1{
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    padding: 5px;
   }
   .interestbtn{
    font-size: 12px;
    padding: 0px;
    align-items: center;
   }
   .postArea{
    padding: 0% 5px;
   }
   .popupinterestbtn{
    padding: 0px;
   }
   .Intcost{
    justify-content: center;
   }
   .modalbody{
    padding: 6px;
   }
   .h4,.pageTitle{
    font-size: 16px;
   }
   .mytxtarea{
  width: 100%;
}
.skilltitle{
    font-size: 14px;
   }
    }
</style>
